/**
 * Shared installment calculation helpers.
 * Pure functions only – no side effects or store access.
 */

export const isValidPositiveNumber = (value) =>
  typeof value === 'number' && !Number.isNaN(value) && value > 0

/**
 * Base installment amount calculation.
 * Returns null when input is not a valid positive number.
 */
export const calculateInstallmentAmount = (price, months) => {
  if (!isValidPositiveNumber(price) || !isValidPositiveNumber(months)) {
    return null
  }
  return Math.ceil((price / months) * 100) / 100
}
